import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import { Link } from 'react-router-dom';
import { CaretDown, CaretUp, Question, MagnifyingGlass } from '@phosphor-icons/react';
import { usePlatform } from '../context/PlatformContext';

const categories = [
  {
    name: 'Umum',
    faqs: [
      { q: "Apa itu Traktirkan?", a: "Traktirkan adalah platform monetisasi kreator Indonesia yang memungkinkan Anda menerima dukungan finansial (traktiran) dari audiens melalui QRIS dan E-Wallet. Mirip seperti Saweria atau Trakteer, tapi dengan fitur overlay streaming yang lebih lengkap." },
      { q: "Apakah Traktirkan gratis?", a: "Ya! Pendaftaran 100% gratis, tanpa biaya bulanan, dan tanpa biaya tersembunyi. Kami hanya memotong 3% dari setiap traktiran yang berhasil masuk." },
      { q: "Siapa yang bisa menggunakan Traktirkan?", a: "Semua kreator digital — streamer, YouTuber, penulis, developer, ilustrator, musisi, podcaster, dan siapapun yang ingin menerima dukungan dari audiensnya." },
    ]
  },
  {
    name: 'Pembayaran & Dana',
    faqs: [
      { q: "Berapa biaya potongannya (fee)?", a: "Kami memotong biaya layanan sebesar 3% dari setiap traktiran yang masuk. Biaya payment gateway (QRIS) ditanggung oleh donatur, bukan kreator." },
      { q: "Bagaimana cara mencairkan dana?", a: "Buka Dashboard → Penarikan → Masukkan jumlah dan detail rekening bank Anda → Klik Tarik Dana. Proses penarikan membutuhkan waktu 1-3 hari kerja." },
      { q: "Berapa minimum penarikan?", a: "Minimum penarikan adalah Rp 10.000. Tidak ada batas maksimum penarikan." },
      { q: "Metode pembayaran apa saja yang didukung?", a: "Kami mendukung pembayaran via QRIS yang bisa dibayar menggunakan GoPay, OVO, Dana, LinkAja, ShopeePay, dan semua E-Wallet yang mendukung QRIS." },
      { q: "Bisa berdonasi dengan nominal kustom?", a: "Tentu! Anda bisa memilih antara 'Per Unit' (misal: 3 Kopi) atau 'Tulis Nominal' untuk memasukkan jumlah uang sesuka Anda (minimal Rp 1.000)." },
    ]
  },
  {
    name: 'Overlay Streaming',
    faqs: [
      { q: "Apa itu Overlay Streaming?", a: "Overlay Streaming adalah widget yang bisa Anda tampilkan di layar live stream (OBS/Streamlabs) untuk menampilkan notifikasi donasi, leaderboard, voting, dan lainnya secara real-time." },
      { q: "Bagaimana cara memasang overlay di OBS?", a: "Buka Dashboard → Overlay → Copy URL widget yang diinginkan → Di OBS, tambah Source → Browser Source → Paste URL → Set resolusi 800x600 → Done!" },
      { q: "Apa saja widget overlay yang tersedia?", a: "Tersedia 9 widget: Alert Box (notifikasi donasi + TTS), Running Text (ticker), Donation Goal (progress bar), Leaderboard (top supporter), Subathon Timer, Media Share (putar video YouTube), Voting (polling interaktif), QR Code (scan langsung dari layar stream), dan Sensor Kata Kasar." },
      { q: "Bagaimana cara voting bekerja?", a: "Kreator membuat polling di Dashboard. Donatur mengirim pesan berisi #1, #2, dst saat mentraktir untuk memberikan suara. Hasil voting ditampilkan real-time di overlay." },
      { q: "Apakah Media Share aman?", a: "Kreator bisa mengontrol antrian media (skip/clear) dari Dashboard. Selain itu, sistem moderasi otomatis akan memfilter pesan donasi yang mengandung kata-kata tidak pantas." },
      { q: "Apa itu TTS (Text-to-Speech)?", a: "TTS membacakan pesan donasi secara otomatis di layar live stream Anda. Anda bisa mengatur bahasa (Indonesia, Inggris, Jepang), volume, dan minimal donasi agar TTS aktif. Aktifkan di Dashboard → Overlay → Pengaturan Alert → TTS." },
      { q: "Bagaimana cara menampilkan QR Code di stream?", a: "Buka Dashboard → Overlay → Copy URL widget QR Code → Tambahkan sebagai Browser Source di OBS (ukuran 350x420). QR Code akan menampilkan link profil Anda agar penonton bisa langsung scan dan traktir. Anda bisa kustomisasi label dan warna aksen." },
    ]
  },
  {
    name: 'Akun & Keamanan',
    faqs: [
      { q: "Apakah Traktirkan aman?", a: "Tentu! Semua transaksi diproses melalui payment gateway berlisensi (Pakasir). Data Anda dilindungi dengan enkripsi standar industri dan kata sandi di-hash menggunakan bcrypt." },
      { q: "Bagaimana cara mengganti password?", a: "Buka Dashboard → Pengaturan → Ubah Password. Jika lupa password, gunakan fitur 'Lupa Password' di halaman login." },
      { q: "Bisa login dengan Google?", a: "Ya! Anda bisa mendaftar dan login menggunakan akun Google untuk kemudahan akses." },
    ]
  },
];

function AccordionItem({ q, a }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="border-2 border-foreground bg-white shadow-brutal-sm">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-4 text-left font-bold hover:bg-background/50 transition-colors">
        <span>{q}</span>
        {isOpen ? <CaretUp weight="bold" className="shrink-0 ml-2" /> : <CaretDown weight="bold" className="shrink-0 ml-2" />}
      </button>
      {isOpen && (
        <div className="p-4 pt-0 text-sm text-foreground/70 border-t-2 border-foreground/10 bg-secondary/10">
          <p className="mt-4 leading-relaxed">{a}</p>
        </div>
      )}
    </div>
  );
}

export default function FAQ() {
  const [search, setSearch] = useState('');
  const { platformConfig } = usePlatform();
  const filtered = categories.map(cat => ({
    ...cat,
    faqs: cat.faqs.filter(f => !search || f.q.toLowerCase().includes(search.toLowerCase()) || f.a.toLowerCase().includes(search.toLowerCase()))
  })).filter(cat => cat.faqs.length > 0);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 py-16">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 border-2 border-foreground bg-primary shadow-brutal mb-4 rotate-3">
            <Question size={32} weight="bold" color="white" />
          </div>
          <h1 className="font-display text-4xl md:text-6xl font-bold tracking-tight">TANYA <span className="text-primary italic">JAWAB</span></h1>
          <p className="text-foreground/60 mt-2 uppercase tracking-widest text-xs font-bold">Frequently Asked Questions</p>
        </div>

        {/* Search */}
        <div className="mb-8 relative">
          <MagnifyingGlass size={18} weight="bold" className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Cari pertanyaan..."
            className="w-full border-2 border-foreground bg-white pl-11 pr-4 py-3 text-sm font-medium shadow-brutal-sm focus:outline-none focus:border-primary"
          />
        </div>

        {filtered.map((cat, ci) => (
          <div key={ci} className="mb-10">
            <div className="flex items-center gap-2 mb-4">
              <div className="h-px bg-foreground/20 flex-1" />
              <span className="text-[10px] font-black uppercase tracking-[0.3em] text-foreground/40">{cat.name}</span>
              <div className="h-px bg-foreground/20 flex-1" />
            </div>
            <div className="space-y-3">
              {cat.faqs.map((f, i) => <AccordionItem key={i} q={f.q} a={f.a} />)}
            </div>
          </div>
        ))}

        <div className="mt-16 border-4 border-foreground bg-foreground text-background p-8 shadow-brutal-xl">
          <h3 className="font-display text-2xl font-bold mb-2">Masih punya pertanyaan?</h3>
          <p className="text-sm opacity-80 mb-6">Jika Anda tidak menemukan jawaban yang Anda cari, hubungi tim kami lewat email atau media sosial.</p>
          <div className="flex flex-wrap gap-3">
            <a href="mailto:support@traktirkan.com" className="inline-block border-2 border-background bg-primary text-white px-6 py-3 font-bold uppercase tracking-wide shadow-[4px_4px_0px_0px_#FFF9E6]">
              Email Support
            </a>
            {platformConfig?.discord_url && (
              <a href={platformConfig.discord_url} target="_blank" rel="noreferrer" className="inline-block border-2 border-background bg-white text-foreground px-6 py-3 font-bold uppercase tracking-wide">
                Discord Server
              </a>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
